import React from 'react';
import "../../../../../Assets/Styles/LoadingIndicator.scss";
import CXLoadingIcon from "../../../../../Assets/Images/CX_loading_icon.svg"
import CXLoadingCircle from "../../../../../Assets/Images/CX_loading_circle.svg"

const ConnexingLoadingIndicatorBlue = () => {
    return (
        <div className="loading-indicator-overlay loading-indicator-overlay-white">
            <img src={CXLoadingCircle} alt="CX-loading-circle" className="icon white"/>
            <img src={CXLoadingIcon} alt="CX-loading-icon" className="centered-icon white" />
        </div>
    );
};

export default ConnexingLoadingIndicatorBlue;
